import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Tablet from './icon-tablet.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Tablet {...validProps} />;
}
SvgComponent.iconName = 'tablet';

/**
 * @deprecated This is a legacy icon
 */
export const TabletIcon = svgIconWrapper(SvgComponent);
